export const removeTags = (str: string) => {
  if (str === null || str === "") return " "
  str = str.toString()

  return str.replace(/(<([^>]+)>)/gi, "")
}
